export const headers = [
    { text: "ID", value: "id", align: "center" },
    { text: "이벤트", value: "eventType", align: "center" },
    { text: "수신자", value: "recipientEmail", align: "center" },
    { text: "제목", value: "subject", align: "start" },
    { text: "상태", value: "status", align: "center" },
    { text: "재시도", value: "retryCount", align: "center" },
    { text: "생성일", value: "createdTime", align: "center" },
    { text: "작업", value: "actions", align: "center", sortable: false },
];
export const statusOptions = [
    { text: "전체", value: "" },
    { text: "성공", value: "success" },
    { text: "재시도 대기", value: "pending_retry" },
    { text: "재시도 중", value: "retrying" },
    { text: "실패", value: "failed" },
];
export const statusColorMap = {
    success: "green",
    pending_retry: "orange",
    retrying: "blue",
    failed: "red",
};
export const statusLabelMap = {
    success: "성공",
    pending_retry: "재시도 대기",
    retrying: "재시도 중",
    failed: "실패",
};
